import { Component, inject, ChangeDetectionStrategy } from '@angular/core'
import { ImportIngredient } from '../../../../../../types/ingredients'
import { MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet'
import { MatDivider } from '@angular/material/divider'
import { MatListModule } from '@angular/material/list'
import { Router } from '@angular/router'
import { TranslationService } from '../../../../../../services/translation.service'
import { CommonModule } from '@angular/common'
import { INGREDIENT_VALIDATION_STATUSES } from '../../../../../../constants/ingredient'

@Component({
  selector: 'app-ingredients-sheet',
  imports: [MatListModule, MatDivider, CommonModule],
  templateUrl: './ingredients-sheet.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './ingredients-sheet.component.scss',
})
export class IngredientsSheetComponent {
  data = inject(MAT_BOTTOM_SHEET_DATA)
  router = inject(Router)
  translationService = inject(TranslationService)

  ingredients: Array<ImportIngredient> = []
  validationStatuses = INGREDIENT_VALIDATION_STATUSES

  // the object injected below has to be any since 'data' is dynamic

  constructor() {
    const data = this.data

    if (data.ingredients) {
      this.ingredients = data.ingredients
    }
  }

  /**
   * Handles the `keydown` event for keyboard navigation.
   * Allows navigating the list using arrow keys and selecting items with Enter.
   *
   * @param {KeyboardEvent} event - The keyboard event triggered when a key is pressed down.
   * @param {number} index - The current index of the focused list item.
   */
  onKeydown(event: KeyboardEvent, index: number): void {
    // Prevent default scroll behavior
    event.preventDefault()
    const listItems = document.querySelectorAll('a[mat-list-item]')

    if (event.key === 'ArrowDown') {
      // Focus the next item, if it exists
      if (index < listItems.length - 1)
        (listItems[index + 1] as HTMLElement).focus()
    } else if (event.key === 'ArrowUp') {
      // If the current index is greater than 0, focus on the previous item
      if (index > 0) (listItems[index - 1] as HTMLElement).focus()
    }
  }

  /**
   * Returns '✔' if the flag is true, otherwise returns '✖'.
   *
   * @param flag - The boolean flag to evaluate.
   * @returns '✔' if `flag` is true, '✖' if `flag` is false.
   */
  getSymbolForFlag(flag: boolean): string {
    return flag ? '✔' : '✖'
  }
}
